export enum StepStatusEnum {
  companyCheck = 'company_check',
  headOfficeCheck = 'head_office_check',
  activityCheck = 'activity_check',
  capitalCheck = 'capital_check',
  responsability = 'responsability',
  physicalPersonPersonalInfoCheck = 'physical_person_personal_info_check',
  physicalPersonContactInfoCheck = 'physical_person_contact_info_check',
  physicalPersonEmployedStatusInfoCheck = 'physical_person_employed_status_info_check',
  physicalPersonSpouseInfoCheck = 'physical_person_spouse_info_check',
  physicalPersonParentsInfoCheck = 'physical_person_parents_info_check',
  allUserInfoCheck = 'all_user_info_check',
  documentCheck = 'document_check',
  signatureCollect = 'signature_collect',
  cps = 'cps_facta',
  kyc = 'kyc',
  registeredOfficeChallenge = 'registered_office_challenge',
  registeredOfficeOffer = 'registered_office_offer',
  registeredOfficeSignature = 'registered_office_signature',
  registeredOfficePayment = 'registered_office_payment',
  registeredOfficeEnd = 'registered_office_end'
}
